import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/buildInfo";
import ErrorBoundary from "@/components/ErrorBoundary";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Privacidad from "@/pages/legal/Privacidad";
import Cookies from "@/pages/legal/Cookies";
import AvisoLegal from "@/pages/legal/AvisoLegal";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: { background: "#0A0A0A", border: "1px solid #2A2A2A", color: "#fff" },
        }}
      />
    </div>
  );
}

export default App;
